// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 fill=%27none%27 viewBox=%270 0 14 14%27%3E%3Cpath d=%27M1 1v4a8 8 0 0 0 8 8h4%27 stroke=%27%23efefef%27 stroke-width=%272%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 fill=%27none%27 viewBox=%270 0 14 14%27%3E%3Cpath d=%27M1 1v4a8 8 0 0 0 8 8h4%27 stroke=%27%23272B30%27 stroke-width=%272%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BD4pN6th2AL7QIWjr0C7.X0uwaxqtkWLjEUP7VSvh .GZvjzZ59B04OogZgjm74 svg:last-child {
  transform: rotate(180deg);
}
.BD4pN6th2AL7QIWjr0C7.X0uwaxqtkWLjEUP7VSvh .ATM559ZzO8n4eSy_YDXU {
  display: block;
}
@media only screen and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.X0uwaxqtkWLjEUP7VSvh .ATM559ZzO8n4eSy_YDXU {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .BD4pN6th2AL7QIWjr0C7.X0uwaxqtkWLjEUP7VSvh .ATM559ZzO8n4eSy_YDXU {
    display: block;
  }
}
@media only screen and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.v0C7834kI3JSNW5cmc_V .GZvjzZ59B04OogZgjm74 {
    font-size: 15px;
  }
}
@media only screen and (max-width: 1259px) and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.v0C7834kI3JSNW5cmc_V .GZvjzZ59B04OogZgjm74 svg:first-child {
    margin-right: 12px;
  }
}
@media only screen and (max-width: 1259px) and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.v0C7834kI3JSNW5cmc_V .GZvjzZ59B04OogZgjm74 svg:last-child {
    display: inline-block;
  }
}
@media only screen and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.v0C7834kI3JSNW5cmc_V .i06T4y3GteKzkL049UL6 {
    display: flex;
  }
}
@media only screen and (max-width: 1259px) {
  .BD4pN6th2AL7QIWjr0C7.v0C7834kI3JSNW5cmc_V.X0uwaxqtkWLjEUP7VSvh .ATM559ZzO8n4eSy_YDXU {
    display: block;
  }
}

.C1wDo9y80zDsZFSbkqXO {
  position: relative;
}
.C1wDo9y80zDsZFSbkqXO.X0uwaxqtkWLjEUP7VSvh .GZvjzZ59B04OogZgjm74 {
  background: #EFEFEF;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF;
  color: #1A1D1F;
}
.dark-mode .C1wDo9y80zDsZFSbkqXO.X0uwaxqtkWLjEUP7VSvh .GZvjzZ59B04OogZgjm74 {
  background: #272B30;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11);
  color: #FCFCFC;
}

.GZvjzZ59B04OogZgjm74 {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 12px;
  border-radius: 12px;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.6;
  color: #6F767E;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transition: background 0.2s, box-shadow 0.2s, color 0.2s;
}
@media only screen and (max-width: 1259px) {
  .GZvjzZ59B04OogZgjm74 {
    font-size: 0;
  }
}
@media only screen and (max-width: 767px) {
  .GZvjzZ59B04OogZgjm74 {
    font-size: 15px;
  }
}
.GZvjzZ59B04OogZgjm74:hover {
  color: #1A1D1F;
}
.GZvjzZ59B04OogZgjm74:hover svg {
  fill: #1A1D1F;
}
.dark-mode .GZvjzZ59B04OogZgjm74:hover {
  color: #FCFCFC;
}
.dark-mode .GZvjzZ59B04OogZgjm74:hover svg {
  fill: #FCFCFC;
}

@media only screen and (max-width: 1259px) {
  .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) {
    background: #EFEFEF;
    box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF;
    color: #1A1D1F;
  }
}
@media only screen and (max-width: 767px) {
  .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) {
    background: none;
    box-shadow: none;
    color: #6F767E;
  }
}
@media only screen and (max-width: 1259px) {
  .dark-mode .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) {
    background: #272B30;
    box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11);
    color: #FCFCFC;
  }
  .dark-mode .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) svg {
    fill: #FCFCFC;
  }
}
@media only screen and (max-width: 767px) {
  .dark-mode .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) {
    background: none;
    box-shadow: none;
    color: #6F767E;
  }
  .dark-mode .GZvjzZ59B04OogZgjm74.X0uwaxqtkWLjEUP7VSvh:not(.v0C7834kI3JSNW5cmc_V) svg {
    fill: #6F767E;
  }
}

.GZvjzZ59B04OogZgjm74 svg {
  flex-shrink: 0;
  fill: #6F767E;
  transition: transform 0.2s, fill 0.2s;
}
.GZvjzZ59B04OogZgjm74 svg:first-child {
  margin-right: 12px;
}
@media only screen and (max-width: 1259px) {
  .GZvjzZ59B04OogZgjm74 svg:first-child {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .GZvjzZ59B04OogZgjm74 svg:first-child {
    margin-right: 12px;
  }
}
.GZvjzZ59B04OogZgjm74 svg:last-child {
  margin-left: auto;
}
@media only screen and (max-width: 1259px) {
  .GZvjzZ59B04OogZgjm74 svg:last-child {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .GZvjzZ59B04OogZgjm74 svg:last-child {
    display: inline-block;
  }
}

.i06T4y3GteKzkL049UL6 {
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 48px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #EFEFEF;
  transform: translateY(-50%);
  font-size: 0;
  transition: border-color 0.2s;
}
@media only screen and (max-width: 1259px) {
  .i06T4y3GteKzkL049UL6 {
    display: none;
  }
}
@media only screen and (max-width: 767px) {
  .i06T4y3GteKzkL049UL6 {
    display: flex;
  }
}
.dark-mode .i06T4y3GteKzkL049UL6 {
  border-color: #33383F;
}

.i06T4y3GteKzkL049UL6 svg {
  fill: #6F767E;
  transition: fill 0.2s;
}
.i06T4y3GteKzkL049UL6:hover {
  border-color: #1A1D1F;
}
.i06T4y3GteKzkL049UL6:hover svg {
  fill: #1A1D1F;
}
.dark-mode .i06T4y3GteKzkL049UL6:hover {
  border-color: #9A9FA5;
}
.dark-mode .i06T4y3GteKzkL049UL6:hover svg {
  fill: #9A9FA5;
}

.i06T4y3GteKzkL049UL6.X0uwaxqtkWLjEUP7VSvh {
  border-color: #9A9FA5;
}
.i06T4y3GteKzkL049UL6.X0uwaxqtkWLjEUP7VSvh svg {
  fill: #9A9FA5;
}

.ATM559ZzO8n4eSy_YDXU {
  position: relative;
  display: none;
  padding-left: 36px;
}
.ATM559ZzO8n4eSy_YDXU:before {
  content: "";
  position: absolute;
  top: 0;
  left: 23px;
  bottom: 32px;
  width: 2px;
  border-radius: 2px;
  background: #EFEFEF;
}
.dark-mode .ATM559ZzO8n4eSy_YDXU:before {
  background: #272B30;
}

.cQHXu7Db34ODlVMWGYXQ {
  position: relative;
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 12px;
  border-radius: 12px;
  color: #6F767E;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  transition: background 0.2s, box-shadow 0.2s, color 0.2s;
}
.cQHXu7Db34ODlVMWGYXQ:before {
  content: "";
  position: absolute;
  top: 12px;
  left: -13px;
  width: 12px;
  height: 12px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 50% 50%/100% auto;
}
.dark-mode .cQHXu7Db34ODlVMWGYXQ:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.cQHXu7Db34ODlVMWGYXQ svg {
  margin-left: auto;
  opacity: 0;
  fill: #1A1D1F;
  transition: opacity 0.2s;
}
.dark-mode .cQHXu7Db34ODlVMWGYXQ svg {
  fill: #FCFCFC;
}

.cQHXu7Db34ODlVMWGYXQ:hover {
  color: #1A1D1F;
}
.dark-mode .cQHXu7Db34ODlVMWGYXQ:hover {
  color: #FCFCFC;
}

.cQHXu7Db34ODlVMWGYXQ.X0uwaxqtkWLjEUP7VSvh {
  background: #EFEFEF;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF;
  color: #1A1D1F;
}
.dark-mode .cQHXu7Db34ODlVMWGYXQ.X0uwaxqtkWLjEUP7VSvh {
  background: #272B30;
  box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11);
  color: #FCFCFC;
}

.cQHXu7Db34ODlVMWGYXQ.X0uwaxqtkWLjEUP7VSvh svg {
  opacity: 1;
}

.P0cJ85XUkMndnmSoIIDd {
  flex-shrink: 0;
  min-width: 24px;
  margin-left: auto;
  border-radius: 6px;
  text-align: center;
  line-height: 24px;
  color: #1A1D1F;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Dropdown/Dropdown.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAMgB;EACI,yBAAA;AALpB;AAMQ;EACI,cAAA;AAJZ;ACKI;EDFI;IAGQ,aAAA;EAFd;AACF;ACMI;EDRI;IAKQ,cAAA;EACd;AACF;ACLI;EDMQ;IACI,eAAA;EAEd;AACF;ACVI;EDSgB;IAEQ,kBAAA;EAG1B;AACF;ACfI;EDYgB;IAEQ,qBAAA;EAK1B;AACF;ACpBI;EDeQ;IACI,aAAA;EAQd;AACF;ACzBI;EDkBI;IAEQ,cAAA;EASd;AACF;;AARA;EACI,kBAAA;AAWJ;AATQ;EACI,mBCOP;EDNO,6EAAA;EACA,cCSP;ADEL;AC2Ia;EDpJG,mBCMX;EDLW,8FAAA;EACA,cCDX;ADaL;;AAVA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EC2BA,eAAA;EACA,gBAAA;EACA,gBAAA;ED3BA,cCTC;EDUD,6CAAA;EACA,wDAAA;AAeJ;AC5DI;EDkCJ;IAaQ,YAAA;EAiBN;AACF;AC3DI;ED4BJ;IAeQ,eAAA;EAoBN;AACF;AApBI;EACI,cCdH;ADoCL;AArBQ;EACI,aChBP;ADuCL;ACsGa;ED3HD,cCxBP;ADgDL;AAvBY;EACI,aC1BX;ADmDL;;AClFI;ED0DA;IAEQ,mBC3BP;ID4BO,6EAAA;IACA,cCzBP;EDoDH;AACF;ACpFI;EDoDA;IAMQ,gBAAA;IACA,gBAAA;IACA,cChCP;ED8DH;AACF;ACjGI;EAkLS;ID7GG,mBCjCX;IDkCW,8FAAA;IACA,cCxCX;EDwEH;EA/Bc;IACI,aC1Cf;ED2EH;AACF;ACrGI;EA4KS;IDvGG,gBAAA;IACA,gBAAA;IACA,cC3CX;ED+EH;EAnCc;IACI,aC7Cf;EDkFH;AACF;;AArCI;EACI,cAAA;EACA,aChDH;EDiDG,qCAAA;AAwCR;AAvCQ;EACI,kBAAA;AAyCZ;AC9HI;EDoFI;IAGQ,eAAA;EA2Cd;AACF;AC7HI;ED8EI;IAKQ,kBAAA;EA8Cd;AACF;AA9CQ;EACI,iBAAA;AAgDZ;AC3II;ED0FI;IAGQ,aAAA;EAkDd;AACF;AC1II;EDoFI;IAKQ,qBAAA;EAqDd;AACF;;AApDA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,6BAAA;AAuDJ;ACrKI;EDiGJ;IAeQ,aAAA;EAyDN;AACF;ACpKI;ED2FJ;IAiBQ,aAAA;EA4DN;AACF;ACGa;ED9DL,qBCjFH;AD+IL;;AA7DI;EACI,aCpFH;EDqFG,qBAAA;AAgER;AA/DI;EACI,qBCpFH;ADqJL;AAhEQ;EACI,aCtFP;ADwJL;ACXa;EDrDD,qBCrFF;ADwJV;AAlEY;EACI,aCvFN;AD2JV;;AAnEI;EACI,qBCzFE;AD+JV;AArEQ;EACI,aC3FF;ADkKV;;AArEA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;AAwEJ;AAvEI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBChHH;ADyLL;ACxCa;ED/BD,mBC/GP;ADyLL;;AAxEA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cC1HC;ED2HD,6CAAA;EACA,wDAAA;AA2EJ;AA1EI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,+EAAA;AA4ER;AChEa;EDVD,yDAAA;AA6EZ;;AA5EI;EACI,iBAAA;EACA,UAAA;EACA,aCvIH;EDwIG,wBAAA;AA+ER;AC1Ea;EDHD,aChJP;ADgOL;;AA/EI;EACI,cC5IH;AD8NL;ACjFa;EDCD,cCpJP;ADuOL;;AAlFI;EACI,mBCpJH;EDqJG,6EAAA;EACA,cClJH;ADuOL;AC1Fa;EDOD,mBCrJP;EDsJO,8FAAA;EACA,cC5JP;ADkPL;;AArFQ;EACI,UAAA;AAwFZ;;AAtFA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cCjKC;AD0PL","sourcesContent":["@import ../../../styles/helpers\n\n.dropdown\n    &.active\n        .head\n            svg\n                &:last-child\n                    transform: rotate(180deg)\n        .body\n            display: block\n            +d\n                display: none\n            +m\n                display: block\n    &.wide\n        +d\n            .head\n                font-size: 15px\n                svg\n                    &:first-child\n                        +d\n                            margin-right: 12px\n                    &:last-child\n                        +d\n                            display: inline-block\n            .add\n                display: flex\n    &.wide.active\n        .body\n            +d\n                display: block\n\n.top\n    position: relative\n    &.active\n        .head\n            background: $n3\n            box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF\n            color: $n7\n            +dark\n                background: $n6\n                box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11)\n                color: $n1\n\n.head\n    display: flex\n    align-items: center\n    width: 100%\n    height: 48px\n    padding: 0 12px\n    border-radius: 12px\n    white-space: nowrap\n    +base1-s\n    color: $n4\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    transition: background .2s, box-shadow .2s, color .2s\n    +d\n        font-size: 0\n    +m\n        font-size: 15px\n    &:hover\n        color: $n7\n        svg\n            fill: $n7\n        +dark\n            color: $n1\n            svg\n                fill: $n1\n    &.active:not(.wide)\n        +d\n            background: $n3\n            box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF\n            color: $n7\n        +m\n            background: none\n            box-shadow: none\n            color: $n4\n        +dark\n            +d\n                background: $n6\n                box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11)\n                color: $n1\n                svg\n                    fill: $n1\n            +m\n                background: none\n                box-shadow: none\n                color: $n4\n                svg\n                    fill: $n4\n    svg\n        flex-shrink: 0\n        fill: $n4\n        transition: transform .2s, fill .2s\n        &:first-child\n            margin-right: 12px\n            +d\n                margin-right: 0\n            +m\n                margin-right: 12px\n        &:last-child\n            margin-left: auto\n            +d\n                display: none\n            +m\n                display: inline-block\n\n.add\n    position: absolute\n    top: 50%\n    display: flex\n    justify-content: center\n    align-items: center\n    right: 48px\n    width: 24px\n    height: 24px\n    border-radius: 50%\n    border: 2px solid $n3\n    transform: translateY(-50%)\n    font-size: 0\n    transition: border-color .2s \n    +d\n        display: none\n    +m\n        display: flex\n    +dark\n        border-color: $n5\n    svg\n        fill: $n4\n        transition: fill .2s\n    &:hover\n        border-color: $n7\n        svg\n            fill: $n7\n        +dark\n            border-color: $shades1\n            svg\n                fill: $shades1\n    &.active\n        border-color: $shades1\n        svg\n            fill: $shades1\n\n.body\n    position: relative\n    display: none\n    padding-left: 36px\n    &:before\n        content: \"\"\n        position: absolute\n        top: 0\n        left: 23px\n        bottom: 32px\n        width: 2px\n        border-radius: 2px\n        background: $n3\n        +dark\n            background: $n6\n\n.link\n    position: relative\n    display: flex\n    align-items: center\n    height: 48px\n    padding: 0 12px\n    border-radius: 12px\n    color: $n4\n    -webkit-tap-highlight-color: rgba(0,0,0,0)\n    transition: background .2s, box-shadow .2s, color .2s\n    &:before\n        content: \"\"\n        position: absolute\n        top: 12px\n        left: -13px\n        width: 12px\n        height: 12px\n        background: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'%3E%3Cpath d='M1 1v4a8 8 0 0 0 8 8h4' stroke='%23efefef' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\") no-repeat 50% 50% / 100% auto\n        +dark\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'%3E%3Cpath d='M1 1v4a8 8 0 0 0 8 8h4' stroke='%23272B30' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")\n    svg\n        margin-left: auto\n        opacity: 0\n        fill: $n7\n        transition: opacity .2s\n        +dark\n            fill: $n1\n    &:hover\n        color: $n7\n        +dark\n            color: $n1\n    &.active\n        background: $n3\n        box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.05), inset 0px 1px 1px #FFFFFF\n        color: $n7\n        +dark\n            background: $n6\n            box-shadow: inset 0px -2px 1px rgba(0, 0, 0, 0.4), inset 0px 1px 1px rgba(255, 255, 255, 0.11)\n            color: $n1\n        svg\n            opacity: 1\n\n.counter\n    flex-shrink: 0\n    min-width: 24px\n    margin-left: auto\n    border-radius: 6px\n    text-align: center\n    line-height: 24px\n    color: $n7","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `BD4pN6th2AL7QIWjr0C7`,
	"active": `X0uwaxqtkWLjEUP7VSvh`,
	"head": `GZvjzZ59B04OogZgjm74`,
	"body": `ATM559ZzO8n4eSy_YDXU`,
	"wide": `v0C7834kI3JSNW5cmc_V`,
	"add": `i06T4y3GteKzkL049UL6`,
	"top": `C1wDo9y80zDsZFSbkqXO`,
	"link": `cQHXu7Db34ODlVMWGYXQ`,
	"counter": `P0cJ85XUkMndnmSoIIDd`
};
export default ___CSS_LOADER_EXPORT___;
